import React from 'react';
import { cssTransition, toast } from 'react-toastify';
import Toast, { Snack } from '../components/Toast';

const titles = {
  success: 'Success',
  error: 'Error',
  info: 'Info',
  warn: 'Warning',
};

const slide = cssTransition({
  enter: 'slide-in-top',
  exit: 'slide-out-top',
});

const customToast = function (type, message) {
  let options = {};
  if (typeof message === 'string') {
    options.message = message;
    options.type = type;
    options.title = titles[type];
  } else if (typeof message === 'object') {
    options = message;
    options.type = type;
  }
  return toast[type](<Toast {...options} />, options);
};

customToast.info = (message) => {
  return customToast('info', message);
};

customToast.error = (message) => {
  return customToast('error', message);
};

customToast.success = (message) => {
  return customToast('success', message);
};

customToast.warn = (message) => {
  return customToast('warn', message);
};

export const snack = (type, message) => {
  const options = {
    autoClose: 3000,
    position: 'top-center',
    closeButton: false,
    hideProgressBar: true,
    closeOnClick: true,
    className: 'snack',
    bodyClassName: 'SnackContainer',
    transition: slide,
  };
  return toast[type](<Snack type={type} message={message} />, options);
};

snack.success = (message) => {
  return snack('success', message);
};

snack.info = (message) => {
  return snack('info', message);
};

snack.warn = (message) => {
  return snack('warn', message);
};

snack.error = (message) => {
  return snack('error', message);
};

snack.loading = (message) => {
  const options = {
    autoClose: false,
    position: 'top-center',
    closeButton: false,
    hideProgressBar: true,
    closeOnClick: true,
    className: 'snack',
    bodyClassName: 'SnackContainer',
  };

  const id = toast['info'](
    <Snack type="loading" message={message} iconProps={{ spin: true }} />,
    options,
  );
  return () => toast.dismiss(id);
};

export default customToast;
